import { notesRailDemoMeetingNotes } from './notesRailDemoMeetingNotes.seed'
import { notesRailDemoRegularNotes } from './notesRailDemoRegularNotes.seed'

/** @type {import('../lib/types.js').NotesRailNoteWire[]} */
export const NOTES_RAIL_DEMO_NOTES = [...notesRailDemoRegularNotes, ...notesRailDemoMeetingNotes]
